import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import PhoneNumberInput from "../../PhoneNumberInput";
import {
  renderErrorsList,
  renderSelectField,
} from '../../../utils/formUtils';
import {
  confirmPhoneNumberAction
} from '../../../redux/actions/profile.actions';
import "./styles.scss";


export class ConfirmNumberForm extends React.Component {
  handleConfirmNumber = (values) => {
    this.props.confirmPhoneNumberAction(values);
  };

  render() {
    const { handleSubmit } = this.props;
    return (
      <div className="col-lg-4 text-center form-margin-container">
        <h3 id="sign-in-brand">Confirm Phone Number</h3>
        <p>To protect users, a code will be sent to you to confirm your phone number.</p>
        <br/>
        <div className="row align-items-center justify-content-center">
          <label id="phone-input-label">Choose country and add phone number</label>
        </div>

        <div className="row align-items-center justify-content-center">

            <form onSubmit={handleSubmit(this.handleConfirmNumber)}>
              <div className="row align-items-center justify-content-center">
                <Field
                  label="Please include your country code"
                  hideLabel={false}
                  name="phoneNumber"
                  type="number"
                  id="phone-number-input"
                  placeholder="Enter Phone Number"
                  textAlign="center"
                  component={PhoneNumberInput}
                />
              </div>

              <div className="row align-items-center justify-content-center">
                <Field
                  label="Receive Code By"
                  hideLabel={false}
                  name="verificationType"
                  type="select"
                  id="verification-type-input"
                  component={renderSelectField}
                  selectOptions={[
                    { value: 'text', text: 'Text' },
                    { value: 'voice', text: 'Voice' }
                  ]}
                  selectOptionText={'text'}
                  selectOptionValue={'value'}
                />
              </div>
              <br/>
              <button
                type="submit"
                id="login-btn"
                className="btn btn-primary">
                Request Code
              </button>
            </form>


        </div>


        <br />
        <ul className="list-group">
          {renderErrorsList(this.props.registration.errors)}
        </ul>
      </div>
    );
  }
}

const mapStateToProps = ({ profile }) => ({ registration: profile.registration });

export default reduxForm({
  form: 'ConfirmNumberForm'
})(connect(mapStateToProps, { confirmPhoneNumberAction })(ConfirmNumberForm));



// WEBPACK FOOTER //
// ./src/components/forms/ConfirmNumberForm/ConfirmNumberForm.jsx